package com.fireavert.yardi.service_requests.data_models.requests.client_requests

import kotlinx.serialization.Serializable

@Serializable
data class YardiClientServiceRequestGetRequest(
    val credentialsId: Int,
    val propertyId: String,
    val serviceId: List<Long>,
)
